// Discount Popup Functions
function openDiscountPopup() {
    const popup = document.getElementById('discountPopup');
    if (popup) {
        popup.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
}

function closeDiscountPopup() {
    const popup = document.getElementById('discountPopup');
    if (popup) {
        popup.style.display = 'none';
        document.body.style.overflow = 'auto'; // Restore scrolling
    }
}

// Close popup when clicking outside the content area

const PageLoaderManager = (function() {
    let loader = null;
    let observers = [];
    let checkInterval = null;
    let fallbackTimeout = null;
    let hidden = false;
    let pageReady = document.readyState === 'complete';

    function disconnectObservers() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers = [];
    }

    function imagesReady(container) {
        const images = container.querySelectorAll('img');
        if (!images.length) {
            return true;
        }
        return Array.prototype.every.call(images, function(img) {
            return img.complete;
        });
    }

    function allSlidersReady() {
        const themeSlideshows = document.querySelectorAll('[id^="Slideshow-"]');
        if (themeSlideshows.length) {
            const themeReady = Array.prototype.every.call(themeSlideshows, function(slider) {
                if (slider.classList.contains('loaded') || slider.classList.contains('flickity-enabled')) {
                    return true;
                }
                if (slider.querySelector('.slideshow__slide.is-selected')) {
                    return imagesReady(slider);
                }
                return false;
            });

            if (!themeReady) {
                return false;
            }
        }

        const customSlideshows = document.querySelectorAll('[id^="CustomSlideshow-"]');
        if (customSlideshows.length) {
            const customReady = Array.prototype.every.call(customSlideshows, function(slider) {
                return imagesReady(slider);
            });

            if (!customReady) {
                return false;
            }
        }

        const vipSelectors = ['#vipTierSlider', '#tierProgressionSlider'];
        const vipSliders = vipSelectors.reduce(function(list, selector) {
            document.querySelectorAll(selector).forEach(function(node) {
                if (list.indexOf(node) === -1) {
                    list.push(node);
                }
            });
            return list;
        }, []);

        if (vipSliders.length) {
            const vipReady = vipSliders.every(function(slider) {
                if (!slider.classList.contains('slick-initialized')) {
                    return false;
                }
                return imagesReady(slider);
            });

            if (!vipReady) {
                return false;
            }
        }

        return true;
    }

    function hideLoader() {
        if (hidden || !loader) {
            return;
        }

        hidden = true;

        if (checkInterval) {
            clearInterval(checkInterval);
            checkInterval = null;
        }

        if (fallbackTimeout) {
            clearTimeout(fallbackTimeout);
            fallbackTimeout = null;
        }

        disconnectObservers();

        loader.classList.add('page-loader--hidden');
        document.body.classList.remove('page-loader-active');

        setTimeout(function() {
            if (loader && loader.parentNode) {
                loader.parentNode.removeChild(loader);
            }
            loader = null;
        }, 500);
    }

    function checkReady() {
        if (!loader || hidden) {
            return;
        }

        if (!pageReady) {
            return;
        }

        if (allSlidersReady()) {
            hideLoader();
        }
    }

    function startChecking() {
        if (!loader || hidden) {
            return;
        }

        if (!checkInterval) {
            checkInterval = setInterval(checkReady, 200);
        }

        if (!fallbackTimeout) {
            fallbackTimeout = setTimeout(function() {
                hideLoader();
            }, 8000);
        }
    }

    function observeSliders() {
        if (!loader || hidden) {
            return;
        }

        disconnectObservers();

        const sliders = document.querySelectorAll('[id^="Slideshow-"], [id^="CustomSlideshow-"], #vipTierSlider, #tierProgressionSlider');
        if (!sliders.length) {
            checkReady();
            return;
        }

        sliders.forEach(function(slider) {
            const observer = new MutationObserver(checkReady);
            observer.observe(slider, { attributes: true, attributeFilter: ['class'] });
            observers.push(observer);
        });
    }

    document.addEventListener('page:loaded', function() {
        pageReady = true;
        checkReady();
    });

    window.addEventListener('load', function() {
        pageReady = true;
        checkReady();
    });

    return {
        init: function() {
            loader = document.getElementById('PageLoader');
            if (!loader) {
                return;
            }

            if (!document.body.classList.contains('page-loader-active')) {
                document.body.classList.add('page-loader-active');
            }

            observeSliders();
            startChecking();
            checkReady();
        },
        refresh: function() {
            if (!loader || hidden) {
                return;
            }
            observeSliders();
            startChecking();
            checkReady();
        }
    };
})();

window.PageLoaderManager = PageLoaderManager;

document.addEventListener('DOMContentLoaded', function() {
    const popup = document.getElementById('discountPopup');
    if (popup) {
        popup.addEventListener('click', function(e) {
            if (e.target === popup) {
                closeDiscountPopup();
            }
        });
    }
    
    // Close popup with Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeDiscountPopup();
        }
    });

        PageLoaderManager.init();
    });

    document.addEventListener('shopify:section:load', function() {
        PageLoaderManager.refresh();

});
